
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.2 16.21V12.4c0-.34-.115-.625-.344-.856A1.164 1.164 0 0016 11.2c-.34 0-.625.115-.854.344-.23.23-.346.516-.346.856V16c0 .4.07.77.21 1.11.14.34.35.65.63.93l2.55 2.55c.24.24.525.36.856.36.33 0 .614-.12.854-.36.22-.24.33-.525.33-.854 0-.33-.11-.606-.33-.826l-2.7-2.7zM16 6.4c-.34 0-.625.115-.854.344-.23.23-.346.516-.346.856 0 .34.115.625.346.856.23.23.514.344.854.344.34 0 .625-.115.856-.344.23-.23.344-.516.344-.856 0-.34-.115-.625-.344-.856A1.164 1.164 0 0016 6.4zm9.6 9.6c0-.34-.115-.625-.346-.856a1.16 1.16 0 00-.854-.344c-.34 0-.625.115-.854.344-.23.23-.346.516-.346.856 0 .34.115.625.346.854.23.23.514.346.854.346.34 0 .625-.115.854-.346.23-.23.346-.514.346-.854zM16 23.2c-.34 0-.625.115-.854.346-.23.23-.346.514-.346.854 0 .34.115.625.346.854.23.23.514.346.854.346.34 0 .625-.115.856-.346.23-.23.344-.514.344-.854 0-.34-.115-.625-.344-.854A1.162 1.162 0 0016 23.2zM8.8 16c0-.34-.115-.625-.344-.856A1.164 1.164 0 007.6 14.8c-.34 0-.625.115-.856.344-.23.23-.344.516-.344.856 0 .34.115.625.344.854.23.23.516.346.856.346.34 0 .625-.115.856-.346.23-.23.344-.514.344-.854zM16 28c-1.66 0-3.22-.315-4.68-.946a12.11 12.11 0 01-3.81-2.564 12.11 12.11 0 01-2.564-3.81C4.316 19.22 4 17.66 4 16c0-1.66.315-3.22.946-4.68A12.11 12.11 0 017.51 7.51a12.127 12.127 0 013.81-2.566C12.78 4.314 14.34 4 16 4c1.66 0 3.22.315 4.68.944 1.46.63 2.73 1.486 3.81 2.566a12.11 12.11 0 012.564 3.81c.63 1.46.946 3.02.946 4.68 0 1.66-.315 3.22-.946 4.68a12.11 12.11 0 01-2.564 3.81 12.11 12.11 0 01-3.81 2.564c-1.46.63-3.02.946-4.68.946z","fill":"#DBCCFF"}})])
          )
        }
      }
    